if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        // Defensive Guards: ohne Form/ID-Feld nicht weiter initialisieren,
        // sonst wirft der Constructor, das Element wird nicht "upgegradet" und
        // das native Form-Submit leitet auf /cart weiter.
        if (!this.form) return;
        const idInput = this.form.querySelector('[name=id]');
        if (idInput) idInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      // Live-Lookup statt einmalig im Constructor: der cart-drawer wird global
      // gerendert, ist aber je nach Reihenfolge zum Constructor-Zeitpunkt evtl.
      // noch nicht im DOM. So wird zur Submit-Zeit korrekt aufgelöst.
      get cart() {
        return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;

            // Auf der Produktseite bleiben und den Warenkorb-Drawer öffnen.
            // Nur wenn gar kein Cart-UI existiert, als letzter Ausweg auf /cart.
            const openCartUi = () => {
              const cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer && typeof cartDrawer.refresh === 'function') {
                cartDrawer.refresh(true);
                return;
              }
              const cartNotification = document.querySelector('cart-notification');
              if (cartNotification && typeof cartNotification.renderContents === 'function') {
                cartNotification.renderContents(response);
                return;
              }
              window.location = window.routes.cart_url;
            };

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(openCartUi);
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              openCartUi();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

var check_cust_val = document.querySelector(".wc_select") || null;
if(check_cust_val){
  check_cust_val.addEventListener("change", function() {
    var val = this.value;
    document.querySelectorAll('.selected-var').forEach(function(element) {
      element.value = val;
    });
    var inputElement = document.getElementById('selling_plan_input');
    if(this.value !== '0'){
      inputElement.setAttribute('name',"selling_plan");
    }else{
      inputElement.removeAttribute('name');
    }
  });
}
document.addEventListener("DOMContentLoaded", function() {
    var selectElement = document.getElementById('selling_plan_select') || null;
    var inputElement = document.getElementById('selling_plan_input') || null;
  
    if (selectElement) {
      if (selectElement.options.length > 0) {
        inputElement.value = selectElement.options[0].value;
      }
    }
    
    if (inputElement) {
      if(inputElement.value === '0'){
        inputElement.removeAttribute('name');
      }
    }    
});